import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import routes from './constants/routes';

const PrivateRoute = ({ component: Component, idToken, ...rest }) => (
  <Route {...rest} render={(props) => (
    idToken
      ? <Component {...props} />
      : <Redirect 
          to={{
            pathname: routes.LOGIN_ROUTE,
          }} 
        />
  )} />
);

const mapStateToProps = (state) => ({
  idToken: state.authReducer.idToken,
});

export default connect(mapStateToProps)(PrivateRoute);
